.betTypeFilters {
  gap: 0;
}

.select label {
  gap: var(--cxy-spacing-2);
  display: flex;
  align-items: center;
}
